"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Field_1 = require("../Field");
var utils_1 = require("../utils");
var BaseControl_1 = require("./BaseControl");
var context_1 = require("../context");
var WithFieldHoc_1 = require("./WithFieldHoc");
// todo: add value property to make field a controlled component
function prepareFieldDefinition(name, props) {
    var form = props.form, _a = props.rules, rules = _a === void 0 ? '' : _a;
    var fieldDefinition = form.formSchema[name];
    if (fieldDefinition) {
        // normalize field definition from initial form schema
        return [fieldDefinition[0], rules ? rules : fieldDefinition[1]];
    }
    else {
        return [props.type === 'checkbox' ? false : '', rules];
    }
}
var Control = /** @class */ (function (_super) {
    __extends(Control, _super);
    function Control(props) {
        var _this = _super.call(this, props) || this;
        var requiredProps = Control_1.requiredProps.slice();
        _this.isRadio = props.type === 'radio';
        _this.isCheckbox = props.type === 'checkbox';
        _this.isFile = props.type === 'file';
        // this.isNumber    = props.type      === 'number';
        _this.isSelect = props.component === 'select';
        _this.isTextarea = props.component === 'textarea';
        _this.isCheckable = _this.isCheckbox || _this.isRadio;
        _this.onChange = _this.onChange.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        if (_this.isRadio) {
            requiredProps.push('value');
        }
        if (!(_this.isSelect || _this.isTextarea)) {
            requiredProps.push('type');
        }
        utils_1.verifyRequiredProps(requiredProps, _this.props, _this);
        if (_this.props.fieldRef) {
            _this.props.fieldRef(_this.props.field);
        }
        return _this;
    }
    Control_1 = Control;
    Control.prototype.componentDidMount = function () {
        var _a = this.props, form = _a.form, field = _a.field;
        this.formErrorUnsubscribe = field.subscribeToFormValidation(form);
    };
    Control.prototype.componentWillUnmount = function () {
        var _a = this.props, form = _a.form, field = _a.field;
        this.formErrorUnsubscribe();
        form.unregisterField(field);
    };
    Control.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.parentName !== prevProps.parentName ||
            this.props.name !== prevProps.name ||
            this.props.rules !== prevProps.rules) {
            var newName = WithFieldHoc_1.constructName(this.props.parentName, this.props.name);
            var newFieldDefinition = prepareFieldDefinition(newName, this.props);
            this.props.field.update(newName, newFieldDefinition);
        }
    };
    Control.prototype.onChange = function (event) {
        var value;
        if (this.isCheckbox) {
            // checkboxes may have(not) a value property that corresponds to true value
            value = (event.target.checked && this.props.value) ? event.target.value : event.target.checked;
        }
        else if (this.isFile) {
            value = event.target.files;
        }
        else {
            value = event.target.value;
        }
        this.props.field.onChange(value);
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    };
    Control.prototype.onFocus = function (event) {
        this.props.field.onFocus();
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    };
    Control.prototype.onBlur = function (event) {
        this.props.field.onBlur();
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    };
    Control.prototype.render = function () {
        // todo: implement withRef today
        var field = this.props.field;
        var handlers = {
            onChange: this.onChange,
            onFocus: this.onFocus,
            onBlur: this.onBlur
        };
        var inputValue = {
            value: (this.isCheckable && this.props.value) ? this.props.value : field.value
        };
        var inputChecked = {
            checked: {}
        };
        if (this.isCheckbox) {
            inputChecked.checked = !!field.value;
        }
        else if (this.isRadio) {
            inputChecked.checked = field.value === this.props.value;
        }
        var meta = {
            focused: field.isFocused,
            touched: field.isTouched,
            dirty: field.isDirty,
            valid: field.isValid,
            errors: field.errors,
            reset: field.reset.bind(field)
        };
        var className = [
            this.props.className,
            meta.touched ? 'rmf-touched' : 'rmf-untouched',
            meta.dirty ? 'rmf-dirty' : 'rmf-pristine',
            meta.valid ? 'rmf-valid' : 'rmf-invalid'
        ].join(' ');
        var input = Object.assign({}, { className: className }, 
        // input type file, and checkbox without value should not have this attribute
        ((this.isFile || (this.isCheckbox && !this.props.value)) ? {} : inputValue), handlers, (this.isCheckable ? inputChecked : {}));
        var propsToPass = utils_1.omit(this.props, BaseControl_1.BaseControl.skipProp.concat(Control_1.skipProp));
        if (typeof this.props.component === 'function') {
            return React.createElement(this.props.component, Object.assign({}, { input: input }, { meta: meta }, propsToPass));
        }
        if (this.props.component === 'select') {
            return React.createElement("select", __assign({}, input, propsToPass), this.props.children);
        }
        // input with text, checkbox, radio, email, number, password type or textarea
        return React.createElement(this.props.component, Object.assign({}, input, propsToPass));
    };
    var Control_1;
    Control.requiredProps = ['component', 'name'];
    Control.skipProp = ['component', 'rules', 'className', 'fieldRef'];
    Control = Control_1 = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Control);
    return Control;
}(React.Component));
exports.Control = Control;
function createField(name, props) {
    var fieldDefinition = prepareFieldDefinition(name, props);
    return new Field_1.Field(name, fieldDefinition);
}
// tslint:disable-next-line: variable-name
exports.ControlWithContext = context_1.withParentName(context_1.withForm(WithFieldHoc_1.withField(Control, createField)));
/*
    private warnOnIncorrectInitialValues(initialValue: fieldValue): void {
        const initialValueType = typeof initialValue; // initial value

        if (this.isSelect) {
            // todo: verify options to match select value
        }

        if (
            (this.isCheckbox && initialValueType !== 'boolean') ||
            (this.isNumber && initialValueType !== 'number') ||
            (!this.isCheckbox && !this.isNumber && initialValueType !== 'string')
        ) {
            // tslint:disable-next-line
            console.warn(`Incorrect initial value provided to field '${this.state.name}'. Got '${initialValueType}'`)
        }
    }
*/
//# sourceMappingURL=Control.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/ui/Control.js
// module id = 80
// module chunks = 0